import { Roles } from 'consts/authConsts'
import { isUserOfRole } from 'utils/authUtils'

export const UserNoteVisiblities = {
  Public: null,
  HI: 'HI'
}

export const AttachmentTypes = {
  Image: 'image'
}

export const NoteTypes = {
  NeedsAttention: 'needsAttention',
  NeedsAttentionResolved: 'needsAttentionResolved'
}

export const buildSearchUserNotesFilter = ({ patientGrinUserId }) => {
  const isAdmin = isUserOfRole([Roles.Admin])
  const isHI = isUserOfRole([Roles.HI])

  return {
    grinUserId: { eq: patientGrinUserId },
    or: [
      {
        visibility: { exists: false } // If visibility is not set, it means the note is visible to all
      },
      isAdmin && {
        visibility: { exists: true } // Admins can see all notes regardless of visibility
      },
      isHI && {
        visibility: { eq: UserNoteVisiblities.HI }
      }
    ].filter(Boolean)
  }
}
